import { IGatsbyImageData } from "gatsby-plugin-image"

export const imageBridgeHelper = (image: IGatsbyImageData | null | undefined) => {

  if (!image) return null

  // set src to the last comma seperated value in srcSet
  // this will be the largest image size
  const src = image.images.fallback?.srcSet?.split(',').pop()?.split(' ').shift() || ''

  return {
    fluid: {
      base64: image.placeholder?.fallback || '',
      src: src,
      srcSet: image.images.fallback?.srcSet || '',
    }
  }

}